import _ from 'underscore';

export const filterAndLocalizeFacebookCampaignsUtil = (campaigns, i18n) => {
  const filteredAndLocalized = _.chain(campaigns)
    .filter((campaign) => {
      const status = campaign.Status;

      return status !== 'Draft' && status !== 'Delete' && status !== 'Deleted';
    })
    .map(({
      Id,
      Name,
      Status,
    }) => ({
      Id,
      Name,
      Status,
      Type: i18n.get('CampaignCampaignType_Audience'), // default type for Facebook campaign
    }))
    .value();

  return filteredAndLocalized;
};
